import { ContextConstants } from "utils/constants";
import { LoginContextState } from "models/propTypes/loginPropTypes";
import { LoginViewActionType } from "models/actionTypes/loginViewActionTypes";

export const LoginReducer = (state: LoginContextState, action: LoginViewActionType): LoginContextState => {
  switch (action.type) {
    case ContextConstants.LoginActions.SET_LOGIN_VIEW:
      return { ...state, loginView: action.payload };
    default:
      return state;
  }
};
